import { Attribute } from '@mark43/cad-api';
import { globalAttributes } from '../global-attributes';

export const groupUnitTypeIdsByClass = (unitTypeAttributes: Attribute[]) => {
    return unitTypeAttributes.reduce(
        (
            obj: Record<'policeUnitTypeIds' | 'fireUnitTypeIds' | 'emsUnitTypeIds', number[]>,
            attr: Attribute
        ) => {
            if (attr.parentAttributeId === globalAttributes.agencyTypeGlobal.POLICE) {
                obj.policeUnitTypeIds.push(attr.id);
            } else if (attr.parentAttributeId === globalAttributes.agencyTypeGlobal.FIRE) {
                obj.fireUnitTypeIds.push(attr.id);
            } else if (attr.parentAttributeId === globalAttributes.agencyTypeGlobal.EMS) {
                obj.emsUnitTypeIds.push(attr.id);
            }

            return obj;
        },
        {
            policeUnitTypeIds: [],
            fireUnitTypeIds: [],
            emsUnitTypeIds: [],
        }
    );
};
